import React, { useState } from 'react';
import { AgentTemplateCards } from '../agent-template-cards';
import { TypingTitle } from '../typing-title';
import type {
  ChatSeedChrome,
  ChatSeedChromeProps,
} from '../../chat-seed/types';

const NEW_AGENT_SEED_HEADINGS = [
  'Have Coco build it for you, or chat with your agent',
  'Get Coco to build your agent, or chat with it',
  'Ask Coco to build it, or chat with your agent',
  'Use Coco to build or chat with your agent',
] as const;

const EXISTING_AGENT_SEED_HEADINGS = [
  'Have Coco edit it for you, or chat with your agent',
  'Get Coco to edit your agent, or chat with it',
  'Ask Coco to edit it, or chat with your agent',
  'Use Coco to edit or chat with your agent',
] as const;

function pickRandomHeading(mode: 'new' | 'existing'): string {
  return (
    (mode === 'new' ? NEW_AGENT_SEED_HEADINGS : EXISTING_AGENT_SEED_HEADINGS)[
      Math.floor(
        Math.random() *
          (mode === 'new'
            ? NEW_AGENT_SEED_HEADINGS.length
            : EXISTING_AGENT_SEED_HEADINGS.length)
      )
    ] ??
    (mode === 'new'
      ? NEW_AGENT_SEED_HEADINGS[0]
      : EXISTING_AGENT_SEED_HEADINGS[0])
  );
}

const AgentChatSeedHeading: React.FC<ChatSeedChromeProps> = ({ isNew }) => {
  const [heading] = useState(() =>
    pickRandomHeading(isNew ? 'new' : 'existing')
  );

  return <TypingTitle text={heading} className="mb-2" />;
};

const AgentChatSeedFooter: React.FC<ChatSeedChromeProps> = ({
  artifactId,
  isNew,
}) => {
  if (isNew !== true) {
    return null;
  }

  return (
    <div className="pt-2 pb-4">
      <AgentTemplateCards agentId={artifactId} />
    </div>
  );
};

export const agentChatSeedChrome: ChatSeedChrome = {
  Heading: AgentChatSeedHeading,
  Footer: AgentChatSeedFooter,
};
